export default __webpack_public_path__ + "static/media/01_DAIF_Data_05.a95ebde9.mp4";